import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';
export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
};